import React from 'react';
import { Link } from 'react-router-dom';
import PageNotFound from 'D:/React/relocator/src/images/PageNotFound.png';
class NotFoundPage extends React.Component{
    render(){
        return <div id="notFound" className="display-1" >
            <img src={PageNotFound} alt="dfsf"  />
            <p style={{textAlign:"center"}}>
              <Link to="/">Go to Home </Link>
            </p>
          </div>;
    }
}
export default NotFoundPage;